import { useState, useEffect, useRef } from 'react';
import {points_precision_lookup} from "hooks/useCrossfilterStore";

function zoom2offset(zoom, min, max){
  return ((zoom - min) / (max - min)) * 300;
}

function offset2zoom(offset, min, max){
  return ((offset / 300) * (max - min)) + min;
}

const MapPointsConfigurator = (props) => {
  const lastY = useRef(0);
  const [state, setState] = useState({
      current_zoom_level: 0,
      h3_1: 0,
      h3_2: 20,
      h3_3: 40,
      h3_4: 60,
      h3_5: 80,
      h3_6: 100,
      h3_7: 120,
      h3_8: 140,
      h3_9: 160,
      h3_10: 180,
      h3_11: 200,
      h3_12: 220,
    }
  );
  
  useEffect(() => {
    if (!props.map) return;
    props.map.on('zoom', updateCurrentZoom);
    updateCurrentZoom();
    return () => props.map.off('zoom', updateCurrentZoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  function updateCurrentZoom(){
    const map = props.map;
    const minZoom = map.getMinZoom();
    const maxZoom = map.getMaxZoom();
    const initialState = {current_zoom_level: zoom2offset(map.getZoom(), minZoom, maxZoom)};
    for(let i in Array(12).fill(null)){
      i = parseInt(i)+1;
      initialState[`h3_${i}`] = zoom2offset(points_precision_lookup[i] || minZoom, minZoom, maxZoom);
    }
    setState(initialState);
  }

  function onDragStart(ev){
    const img = document.createElement('img');
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    ev.dataTransfer.setDragImage(img, 0, 0);
    lastY.current = ev.screenY;
  }

  function onDragHandle(level, ev){
    if(ev.screenY === 0) return;
    const diff = ev.screenY - lastY.current;
    lastY.current = ev.screenY;
    const key = `h3_${level}`;
    setState(prev => ({...prev, [key]: prev[key] + diff}));
  }

  function onDragEndHandle(){
    const min = props.map.getMinZoom();
    const max = props.map.getMaxZoom();
    for(let i in Array(12).fill(null)) {
      i = parseInt(i)+1;
      points_precision_lookup[i] = offset2zoom(state[`h3_${i}`], min, max);
    }
  }

  const disabled = !localStorage.getItem('map-points-configurator');
  return disabled ? null
                  : (
      <div className='map-control expandable-map-control map-points-configurator'>
        {[1,2,3,4,5,6,7,8,9,10,11,12].map( i =>
          <div className='handle' style={{top: state[`h3_${i}`]+'px'}} key={i}
                draggable={true}
                onDragStart={onDragStart}
                onDrag={(ev) => onDragHandle(i, ev)}
                onDragEnd={onDragEndHandle}>{i}</div>
        )}
        <div className='current-zoom-level' style={{top: state.current_zoom_level+'px'}} />
      </div>
  );
}
export default MapPointsConfigurator;
